import React, {MouseEvent} from "react"
import Modal from "./Modal";
import ModalDialogOption from "./ModalDialogOption";

export interface ModalAction {
    value: string,
    onClick?: (event: MouseEvent) => void,
    keepModalShown?: boolean,
    isFileInput?: boolean,
    onChange?: (value: File) => void
}

export interface Props {
    id: string,
    show?: boolean,
    onDismiss?: (event: MouseEvent) => void,
    actions: Array<ModalAction>
}

export default (props: Props) => {
    const {id, show, onDismiss, actions} = props;

    return (
        <Modal
            id={id}
            show={show}
            bottom
            onDismiss={onDismiss}>

            {actions.map(({value, onClick, isFileInput, onChange}, i) =>
                <ModalDialogOption key={`ModalDialogOption_${i}`} first={i === 0}
                                   onClick={onClick}
                                   onChange={onChange}
                                   isFileInput={isFileInput}
                                   last={i === actions.length - 1}
                                   grey={i === actions.length - 1}
                                   value={value}/>)}

        </Modal>
    );
}


